<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm"
                :to="{ name: 'PortForwardingList' }"
              >
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Port Forwarding
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Port Forwarding</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>
              <div class="card-header">
                <h3 class="card-title">Detail</h3>
              </div>
              <div class="card-body">
                <div class="custom-list">
                  <ul>
                    <li><strong>ID</strong> {{ value.id }}</li>

                    <li><strong>Audra Name</strong> {{ value.accountId }}</li>

                    <li><strong>Dest. Port</strong> {{ value.port_to }}</li>

                    <li><strong>Src Port</strong> {{ value.port_from }}</li>

                    <li>
                      <strong>Host IP</strong> {{ value.host_ip_address }}
                    </li>

                    <li><strong>Src IP</strong> {{ value.src_ip_address }}</li>

                    <li><strong>Protocol</strong> {{ value.tcp_udp }}</li>

                    <li><strong>State</strong> {{ value.status }}</li>

                    <li>
                      <strong>Description</strong> {{ value.description }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from '@/services/api'
import axios from 'axios'
const fileDownload = require('js-file-download')
import { Notification } from 'element-ui'

export default {
  name: 'PortForwardingShow',
  metaInfo: {
    title: 'Port Forwarding | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: 'arraybuffer' })
        .then(response => {
          fileDownload(response.data, url.replaceAll('/', '-'))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({
            title: 'Download Failed',
            message: 'Failed to download',
            type: 'error'
          })
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/port_forwardings/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {})
      })
    }
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
